import { Order } from '../classes/order.class';

export function upDateTasksInHour(workerOrdersMap: Map<number, Order[]>): number {// по умолчанию 5 заявок в час;
    const time = new Map<string, number>();
    const tasksInHourDefault = 5;

    const results = Array.from(workerOrdersMap.values()).map((orderGroup) => {
        const orders = orderGroup.map(order => order.data);
        return orders.reduce((acc, order) => {
            const dateFrom = new Date(order.dateFrom).getHours();
            const dateTo = new Date(order.dateTo).getHours();
            const targetHour = dateFrom;
            acc[targetHour] = {
                count:(acc[targetHour]?.count || 0) + 1,
                time: `${dateFrom}-${dateTo}`,
            };

            return acc;
        }, {} as { [key: string]: { count: number, time: string } });
    });

    const overlappedResults = results.every(orderObject => {
        const keys = Object.keys(orderObject).map(Number).sort((a, b) => a - b);
        if (keys.length === 0) {
            return true;
        }

        for (let i = 0; i < keys.length - 1; i++) {
            const currentTime = orderObject[keys[i]].time;
            const nextTime = orderObject[keys[i + 1]].time;
            const currentEnd = parseInt(currentTime.split('-')[1]);
            const nextStart = parseInt(nextTime.split('-')[0]);
            // Разрешаем пропуски времени - проверяем только что нет наложения
            if (currentEnd > nextStart) {
                return false; // Есть наложение интервалов
            }
        }
        return true;
    });
    // проверяем если не стандартный кейс пример идет очередь заявок с 9-12 и поставили например 10-12

    results.forEach(hourObject => {
        Object.entries(hourObject).forEach(([_, data]) => {
            const currentCount = time.get(data.time);
            if (!currentCount) {
                time.set(data.time, data.count);
            }

            if (currentCount && data.count > currentCount) {
                time.set(data.time, data.count);
            }
        });
    });
    // для сохранения максимального значения заявок

    const res = Array.from(time).map(([key,value]) => {
        return {
            time: key,
            count: value
        };
    });

    if (!res.length) {
        return tasksInHourDefault;
    }

    const maxObject = res.reduce((max, item) => {
        return item.count > max.count ? item : max;
    });
    ///находим максимальное из всех заявок самое большое зачтения

    const [dateTo, dateFrom] = maxObject.time.split('-');

    const periodTime = (Number(dateFrom) - Number(dateTo));
    const counterTask = periodTime * tasksInHourDefault;
    /// dateFrom = 9 dateTo = 12 отнимаем получаем 3 * tasksInHourDefault получаем 15 находим количество заявок за промежуток времени

    if (maxObject.count < counterTask && overlappedResults) {
        return tasksInHourDefault;
    }

    if (maxObject.count > counterTask && overlappedResults) {
        return Math.ceil(maxObject.count / periodTime);
    }

    if (!overlappedResults) {
        return maxObject.count;
    }

    return tasksInHourDefault;

///для обновления временной шкалы количество заявок в один час this.tasksInHour;
}
